
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Button } from '@/components/ui/button';
import { LogOut, Camera, ChevronLeft } from 'lucide-react';

export const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isInnerPage = window.location.pathname !== '/';
  
  return (
    <header className="sticky top-0 bg-bauhaus-offwhite z-10 border-b border-bauhaus-green/20 shadow-lg pt-safe text-bauhaus-darkgreen">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        {isInnerPage ? (
          <button 
            onClick={() => navigate(-1)} 
            className="flex items-center font-medium text-bauhaus-darkgreen"
          >
            <ChevronLeft className="h-5 w-5 mr-1" />
            BACK
          </button>
        ) : (
          <div className="flex items-center gap-2">
            <div className="bg-bauhaus-green p-1.5 rounded-lg shadow-lg">
              <Camera className="h-5 w-5 text-bauhaus-offwhite" />
            </div>
            <h1 className="text-xl font-bold text-bauhaus-darkgreen tracking-wider uppercase font-['Bebas_Neue']">
              Foto Fight
            </h1>
          </div>
        )}
        
        {user ? (
          <div className="flex items-center gap-3">
            <div className="bg-bauhaus-green text-bauhaus-offwhite rounded-md px-3 py-1 text-sm font-bold shadow-md">
              <span className="font-bold">{user.points}</span> pts
            </div>
            <Button
              variant="outline"
              size="icon"
              className="rounded-md border-bauhaus-darkgreen hover:bg-bauhaus-darkgreen/10 text-bauhaus-darkgreen"
              onClick={() => {
                logout();
                navigate('/');
              }}
              aria-label="Log out"
            >
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        ) : (
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate('/auth')}
            className="border-bauhaus-darkgreen text-bauhaus-darkgreen hover:bg-bauhaus-darkgreen/10"
          >
            LOGIN
          </Button>
        )}
      </div>
    </header>
  );
};
